export const MANAGEMENT_DASHBOARD_TABS = {
  EXECUTIVE: "executive",
  OPERATIONS: "operations",
  CONTRACTORS: "contractors",
  LENDING: "lending",
  GEOGRAPHY: "geography",
  ASSETS: "assets",
  CONTROL: "control",
};

export const MANAGEMENT_DASHBOARD_TAB_ITEMS = [
  { id: MANAGEMENT_DASHBOARD_TABS.EXECUTIVE, label: "نمای اجرایی" },
  { id: MANAGEMENT_DASHBOARD_TABS.OPERATIONS, label: "کنترل عملیات" },
  { id: MANAGEMENT_DASHBOARD_TABS.CONTRACTORS, label: "پیمانکاران" },
  { id: MANAGEMENT_DASHBOARD_TABS.LENDING, label: "وام و مالی" },
  { id: MANAGEMENT_DASHBOARD_TABS.GEOGRAPHY, label: "جغرافیا" },
  { id: MANAGEMENT_DASHBOARD_TABS.ASSETS, label: "دارایی و انرژی" },
  { id: MANAGEMENT_DASHBOARD_TABS.CONTROL, label: "مرکز کنترل" },
];

export const DEFAULT_MANAGEMENT_TAB = MANAGEMENT_DASHBOARD_TABS.EXECUTIVE;

/**
 * Lazy-load map: which API loaders each tab needs.
 * Only the active tab (+ shared core once) should hit the network.
 */
export const MANAGEMENT_TAB_LOADER_KEYS = {
  [MANAGEMENT_DASHBOARD_TABS.EXECUTIVE]: [
    "executiveKpis",
    "alerts",
    "healthScore",
    "executiveBrief",
    "benchmark",
    "funnel",
  ],
  [MANAGEMENT_DASHBOARD_TABS.OPERATIONS]: [
    "readiness",
    "stageAging",
    "bottlenecks",
    "criticalCases",
    "trends",
  ],
  [MANAGEMENT_DASHBOARD_TABS.CONTRACTORS]: [
    "contractorPerformance",
    "acquisition",
    "executiveKpis",
  ],
  [MANAGEMENT_DASHBOARD_TABS.LENDING]: [
    "lending",
    "mehrsan",
    "loanPartnerPerformance",
  ],
  [MANAGEMENT_DASHBOARD_TABS.GEOGRAPHY]: [
    "acquisition",
    "bottlenecks",
  ],
  [MANAGEMENT_DASHBOARD_TABS.ASSETS]: [
    "executiveKpis",
  ],
  [MANAGEMENT_DASHBOARD_TABS.CONTROL]: [
    "actionCenter",
    "workflowActions",
    "alerts",
    "readiness",
    "sla",
    "riskPredictions",
  ],
};

/** Session cache TTL for dashboard GET payloads (ms). */
export const DASHBOARD_CACHE_TTL_MS = 60_000;

/** Maps executive overview KPI slots to backend KPI codes (GetExecutiveKpis). */
export const EXECUTIVE_OVERVIEW_KPI_SPECS = [
  {
    slot: "totalRequests",
    title: "کل درخواست‌ها",
    description: "درخواست‌های ثبت‌شده در بازه",
    kpiCodes: ["NewApplicants"],
    overviewKey: "totalRequests",
  },
  {
    slot: "activeRequests",
    title: "درخواست‌های فعال",
    description: "در جریان (InProcess)",
    kpiCodes: ["ActiveApplicants"],
  },
  {
    slot: "pipelineCapacity",
    title: "ظرفیت خط لوله فعال",
    description: "kW / MW",
    kpiCodes: ["ActivePipelineCapacityKw"],
  },
  {
    slot: "totalContracts",
    title: "قراردادهای تأییدشده",
    description: "پیشنهاد/قرارداد مشتری",
    kpiCodes: ["ApprovedCustomerContractValue", "InitiallyApproved"],
  },
  {
    slot: "installedPlants",
    title: "نیروگاه‌های بهره‌برداری",
    description: "دارای پروانه بهره‌برداری",
    kpiCodes: ["CommissionedProjects"],
    overviewKey: "operatingPlants",
  },
  {
    slot: "installedCapacity",
    title: "ظرفیت نصب‌شده",
    description: "kW / MW",
    kpiCodes: ["CommissionedCapacityKw"],
  },
  {
    slot: "conversionRate",
    title: "نرخ تبدیل کلی",
    description: "کاربر → درخواست (رشد)",
    growthKey: "averageConversionRate",
  },
  {
    slot: "loanPipeline",
    title: "ارزش خط لوله وام",
    description: "تأمین مالی تأییدشده",
    kpiCodes: ["ApprovedFinancingAmount"],
  },
];
